/**
*
* RedSpeakers
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import selectSpeakerById from 'helpers/selectSpeakerById';

import Wrapper from 'components/Templates/dynamics/Wrapper';
import AddTemplateData from 'components/Templates/dynamics/AddTemplateData';

import RedSpeakersSpeaker from './RedSpeakersSpeaker';

import defaultTextValues from './defaultTextValues';

class RedSpeakers extends React.PureComponent {

  render() {
    const {
      commonData,
      openEditor,
      commonProps,
      speakers,
      setShowPopup,
    } = this.props;

    const {
      isEditor,
      helpers
    } = commonProps;

    const {
      componentPayload
    } = commonData;

    const {
      companyLogoType,
      sectionId
    } = componentPayload;

    const addSpeakerContent = (
      <AddTemplateData
        editorData={{
          editorType: 'wrapper',
          ...commonData
        }}
        helpers={helpers}
        setShowPopup={setShowPopup}
        popupValue={'speakers-view'}
        title={'Manage Speakers'}
      />
    );

    const thisSpeakerList = componentPayload && componentPayload.speakers ? componentPayload.speakers : '';

    const speakersContent = thisSpeakerList && thisSpeakerList.length > 0 ? thisSpeakerList.map((speaker, i) => {

      const thisSpeaker = selectSpeakerById(speakers, speaker);
      if (!thisSpeaker) return '';

      return (
        <RedSpeakersSpeaker
          key={'RedSpeakersSpeaker-'+speaker+sectionId}
          commonData={commonData}
          
          commonProps={commonProps}
          thisSpeaker={thisSpeaker}
          speakerCompany={thisSpeaker.speakerCompany}
          companyLogoType={companyLogoType}
          isSingle={true}
        />
      );
    }) : '';

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'sectionTitleWrapper'}
            editorData={
              {
                editorType: 'sectionTitleWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'sectionTitle'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'sectionTitle',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'paragraph'}
              type={'text'}
              defaultValues={defaultTextValues}
              editorData={
                {
                  editorType: 'paragraph',
                  ...commonData
                }
              }
            />
          </Wrapper>
          {
            speakersContent ? (
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'allSpeakersWrapper'}
                editorData={
                  {
                    editorType: 'allSpeakersWrapper',
                    ...commonData
                  }
                }
              >
                {speakersContent}
              </Wrapper>
            ) : ''
          }  
          {isEditor ? addSpeakerContent : ''}
        </Wrapper>
      </Wrapper>
    );


  }
}

RedSpeakers.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  speakers: PropTypes.array,
  setShowPopup: PropTypes.func,
  defaultValues: PropTypes.object,
  thisSpeaker: PropTypes.object,
  companies: PropTypes.array,
};

export default RedSpeakers;
